import timeZonesEnam from "@/constant/timeZonesEnam";

export const timezoneOffsets = {
        [timeZonesEnam.GMT_MINUS_3]: 3,
        [timeZonesEnam.GMT_MINUS_4]: 4,
        [timeZonesEnam.GMT_MINUS_5]: 5,
        [timeZonesEnam.GMT_MINUS_6]: 6,
        [timeZonesEnam.GMT_MINUS_7]: 7,
        [timeZonesEnam.GMT_MINUS_8]: 8,
        [timeZonesEnam.GMT_MINUS_9]: 9,
        [timeZonesEnam.GMT_MINUS_10]: 10,
        [timeZonesEnam.GMT_MINUS_11]: 11
};